import { useEffect, useState } from "react";

type LocalStorageValue = boolean | string | number | object | undefined | null;

export const useLocalStorage = (
  key: string,
  initialValue: LocalStorageValue,
): [LocalStorageValue, (value: LocalStorageValue) => void] => {
  // Start from the initial value, as the server does, and read storage once
  // mounted, so the first render in the browser matches the server's HTML.
  const [state, setState] = useState<LocalStorageValue>(initialValue);

  useEffect(() => {
    try {
      const value = window.localStorage.getItem(key);
      if (value) {
        setState(JSON.parse(value));
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }, [key]);

  const setValue = (value: LocalStorageValue) => {
    try {
      // If the passed value is a callback function,
      //  then call it with the existing state.
      const valueToStore = value;
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
      setState(valueToStore);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  return [state, setValue];
};
